"use client";

import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import NotificationItem from "./NotificationItem";
import NotificationEmptyState from "./NotificationEmptyState";
// import notificationData from "../notificationData";

import styles from "../notification.module.css";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const NotificationMenu = React.forwardRef(({ onClose, notifications }, ref) => {
  const hasNotifications = Array.isArray(notifications) && notifications.length;

  return (
    <div
      ref={ref}
      className={styles.notification_menu_container}
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="notification-title"
    >
      <header>
        <FontAwesomeIcon icon={faBell} className={styles.bell} />
        <h3 id="notification-title">Notifications</h3>
        <div
          className={styles.closeButton}
          onClick={(e) => {
            e.stopPropagation();
            if (onClose) {
              onClose();
            }
          }}
          role="button"
          tabIndex={0}
          aria-label="Close notification menu"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              if (onClose) {
                onClose();
              }
            }
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </div>
      </header>
      <div
        style={{
          overflowY: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: "#e5e7eb #f8fafc",
        }}
      >
        <main className={styles.notifications_container}>
          {hasNotifications ? (
            notifications.map((notificationData, index) => {
              return (
                <NotificationItem
                  notificationData={notificationData}
                  key={index}
                  isLatest={index == 0}
                />
              );
            })
          ) : (
            <NotificationEmptyState />
          )}
        </main>
      </div>
    </div>
  );
});

export default NotificationMenu;
